
import React, { Fragment } from "react";

import SweetAlert from 'sweetalert2';
import { toast } from "react-toastify";

import { walletsService } from 'Services';
import TableRowDelete from 'CommonElements/Table/TableRowDelete';


const DeleteWallet = ({ data={}, loadData }) => {


  const deleteWallet = () => {
    SweetAlert.fire({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to recover this record!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'cancel',
        reverseButtons: true,
    }).then((result) => {
        if (result.value) {
            walletsService.deleteWallet(data.id).then(res => {
                toast.success('Wallet delete, successfully');
                loadData();
            }).catch(err => {
                toast.error('Failed to delete Wallet');

            })
        }
    });
};
  return (
    <Fragment>
        <TableRowDelete onClick={deleteWallet} />

    </Fragment>
  );
};

export default DeleteWallet;
